// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .close-row {\n  background: #ffaba0;\n}\n.agency-select-item .el-form-item__content {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
